/*
* Configuration for Search
*/
export default function (data) {
  return {
    widgets: [
      {
        widgetId: 'SystemProducts',
        widgetEnable: true,
        data: {
          parentClasses: 'bg-gray-50 pb-12 xl:pb-16',
          parentStyle: 'secondStyle',
          showLabel: true,
          productCard: {
            cardWidgetId: false,
            cardWidgetPlaceholderId: false,
            aspectSquare: false,
            showColors: true,
            showBadges: true,
            showLabel: true,
            showPrice: true,
            isLargeCardSecondStyle: false,
            isLargeCardShowBanner: false
          },
          filters: {
            widgetEnable: true,
            parentClasses: 'pt-0',
            elementClassesFirst: 'pt-12 xl:pt-16',
            elementClassesSecond: 'pt-12 xl:pt-16',
            headline: false,
            searchEnable: false,
            viewTypeEnable: true,
            filterByPriceEnable: false,
            filteringEnable: true,
            items: false
          },
          products: {
            parentClasses: 'pt-6 lx:pt-8',
            categoryId: data?.categoryPathname,
            categoryFilter: data?.categoryFilter,
            limit: 26,
            gap: 4,
            defaultElClasses: 'w-full md:w-1/2 lg:w-1/3',
            gridClasses: '-mx-2 md:-mx-4',
            elClasses: 'p-2 md:p-4',
            grid: false
          }
        }
      }
    ]
  }
}
